// Main index file - imports and exports both language versions

// Import English version (your existing file - just rename it)
import { voterAwarenessBlogs as voterAwarenessBlogsEn, blogCategories as blogCategoriesEn } from './voterAwarenessBlogs.en';

// Import Hindi version (new file to create)
import { voterAwarenessBlogsHi, blogCategoriesHi } from './voterAwarenessBlogs.hi';

// Function to get blogs based on language
export const getVoterAwarenessBlogs = (language = 'en') => {
  return language === 'hi' ? voterAwarenessBlogsHi : voterAwarenessBlogsEn;
};

// Function to get categories based on language
export const getBlogCategories = (language = 'en') => {
  return language === 'hi' ? blogCategoriesHi : blogCategoriesEn;
};

// For backward compatibility (default to English)
export const voterAwarenessBlogs = voterAwarenessBlogsEn;
export const blogCategories = blogCategoriesEn;
